import React, { useState, useEffect, useContext } from 'react'
import { getApiTargetInfo } from 'core'
import R from 'ramda'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import { solarPlantSelection, getSystemConfigurationInfo } from 'api/pgads'
import { DataContext, ErrorContext } from 'context'
import { getSolarMissingData } from './solarapi'
import { DatePicker, message, Select, Button, Modal, Input } from 'antd'
import moment from 'moment'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'

export const SolarMissingDataHeaders = [
  strCol({
    ident: 'frequency',
    display: 'Frequency',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'transDate',
    display: 'TransDate',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'missingInterval',
    display: 'Missing Interval',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
  }),
  strCol({
    ident: 'tags',
    display: 'Tags',
    isFiltered: true,
    width: 1000,
    alignment: 'left',
    ellipsis: true,
  }),
]
const title = 'Solar PI Missing Data'

const SolarMissingData = ({ apiTargetInfo }) => {
  const [plants, setPlants] = useState([])
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment(),
    moment(),
  ])
  const [showDetails, setShowDetails] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const {
    selectedSolarPlant,
    setSelectedSolarPlant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedSolarPlant)
    ? selectedSolarPlant[0]
    : selectedSolarPlant
  const [solarMissingDataDaysGap, setSolarMissingDataDaysGap] = useState()

  const { setError } = useContext(ErrorContext)

  useEffect(
    _ => {
      solarPlantSelection(apiTargetInfo)({
        year: selectedDateRangePicker[1].format('YYYY'),
        month: selectedDateRangePicker[1].format('MM'),
      }).fork(setError, data => {
        const sd = R.sortBy(R.prop('plantName'), data)
        setPlants(sd)
        if (!plantSelected && sd[0] && sd[0].plantId)
          setPlantSelected([sd[0].plantId])
      })

      getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
        const dateRange = d.find(
          s => s.key === 'SOLAR_MISSING_DATA_DAYS_LIMIT'
        ) || { value: 31 }
        setSolarMissingDataDaysGap(dateRange.value)
      })
    },
    [
      apiTargetInfo,
      plantSelected,
      selectedDateRangePicker,
      setError,
      setPlantSelected,
    ]
  )
  const beforeRetrieveValidation = () => {
    if (!plantSelected) {
      message.warning('Please, Select a Plant')
      return false
    }
    const startDate = selectedDateRangePicker[0]
    const endDate = selectedDateRangePicker[1]

    const isValid =
      endDate.diff(startDate, 'days') <= parseInt(solarMissingDataDaysGap)
    if (!isValid) {
      message.error(
        'Selected date range should be within ' +
          solarMissingDataDaysGap +
          ' days.'
      )
    }
    return isValid
  }

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <div>
        <Select
          showSearch
          style={{ width: '200px' }}
          placeholder="Select Plant"
          onChange={value => setPlantSelected([value])}
          value={plantSelected}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {plants.map(item => (
            <Select.Option key={item.plantId} value={item.plantId}>
              {item.plantName}
            </Select.Option>
          ))}
        </Select>
        <DatePicker.RangePicker
          style={{ marginLeft: '10px' }}
          allowClear={false}
          format="MM/DD/YYYY"
          value={selectedDateRangePicker}
          onChange={d => {
            setSelectedDateRagePicker(d)
            onChange()
          }}
        />
      </div>
    )
  }

  const extraCriteriaAfterButton = ({ selectedRows }) => {
    const tagList = selectedRows?.selectedRows[0]?.tags
      .split(',')
      .filter(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()))
    return (
      <div>
        <Modal
          title="Deatil Data"
          width="80vw"
          visible={showDetails}
          // open={showDetails}
          footer={[
            <Button key="cancle" onClick={() => setShowDetails(false)}>
              Cancel
            </Button>,
          ]}
          onCancel={() => setShowDetails(false)}
          destroyOnClose
          closable
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px 7px',
            }}
          >
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Frequency
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.frequency}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                TransDate
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.transDate}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <span style={{ display: 'block', marginBottom: '5px' }}>
                Missing Interval
              </span>
              <Input
                value={selectedRows?.selectedRows[0]?.missingInterval}
                style={{ width: '100%' }}
              />
            </div>
            <div style={{ gridColumn: 'span 3' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}
              >
                <span style={{ marginRight: '10px' }}>Tags:</span>
                <input
                  type="text"
                  placeholder="Search tags..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  style={{
                    flex: '1',
                    maxWidth: '400px',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                  }}
                />
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                  alignContent: 'flex-start',
                  maxHeight: '45vh',
                  height: '45vh',
                  overflow: 'auto',
                  border: '1px solid #eee',
                  borderRadius: '5px',
                  paddingTop: '10px',
                  paddingBottom: '0px',
                  // gap: '10px',
                }}
              >
                {tagList?.map((tag, index) => (
                  <div
                    key={tag + index}
                    style={{
                      // height: '30px',
                      overflow: 'wrap',
                      flex: '0 0 80px',
                      width: 'max-content',
                      paddingTop: '5px',
                      paddingLeft: '10px',
                    }}
                  >
                    <p>{tag}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
        <Button
          onClick={() => setShowDetails(true)}
          type="primary"
          disabled={
            selectedRows?.selectedRows &&
            selectedRows?.selectedRows?.length <= 0
          }
          // style={{ marginLeft: '10px' }}
        >
          Show Details
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={SolarMissingDataHeaders}
      retrieveTask={getSolarMissingData}
      withCriteria={_ => ({
        start: selectedDateRangePicker[0],
        end: selectedDateRangePicker[1],
        plant: plantSelected,
      })}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      beforeRetrieveValidation={beforeRetrieveValidation}
      screenCriteria={screenCriteria}
      sortOptions={SolarMissingDataHeaders}
      allowInsert={false}
      isEditableGrid={_ => false}
      isAdminScreen={false}
      withoutModify
      widthOffset={50}
      autoFixColByKey={false}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarMissingData)
